<template>
    <div class="form">
        <v-layout>
            <v-flex xs12>
                <v-layout row>
                    <v-flex md12>
                        <div class="content-wrapper">
                            <div class="info-block">
                                Assign user to organizations and fleets
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex md12>
                        <tree-view
                            :flat-list="originalFlatList"
                            :is-loading="isLoading"
                            @onUpdateAssignedOrganizationsAndFleets="updateAssignedOrganizationsAndFleets"
                        ></tree-view>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <sp-loader v-if="isLoading"></sp-loader>
    </div>
</template>

<script>

import TreeView from '@/views/Users/components/TreeView'
import UserApi from '@/api/UserApi'
import toast from '@/plugins/izitoast'
import { subtractSet } from '@/helpers/Utils'
import SpLoader from '@/components/atoms/Loader'

const userApi = new UserApi()

export default {
    name: 'AssignToOrgAndFleets',
    mounted () {
        this.id = this.$route.params.id
        this.getOrganizationsAndFleetsToAssign()
    },
    components: {
        TreeView,
        SpLoader
    },
    data () {
        return {
            id: null,
            treeList: [],
            originalFlatList: [],
            copiedFlatList: [],
            assignedFleets: [],
            assignedOrganizations: [],
            isLoading: false,
            idsAsProperties: {}
        }
    },
    methods: {
        async getOrganizationsAndFleetsToAssign () {
            if (!this.hasAllRoles(['UserUpdate'])) {
                return
            }

            this.isLoading = true
            const response = await userApi.getOrganizationsToAssign(this.id)
            if (!response.isSuccess) {
                this.isLoading = false
                return
            }

            this.sortOrganizationsAndFleets(response.payload)
            this.pickAssignedItems(response.payload)
            this.originalFlatList = response.payload.slice()
            this.isLoading = false
        },
        pickAssignedItems (assignedArray) {
            const assignedOrganizations = []
            const assignedFleets = []
            assignedArray.forEach(el => {
                if (el.isAssigned) assignedOrganizations.push(el.id)
                if (0 < el.fleets.length) {
                    el.fleets.forEach(fleet => {
                        if (fleet.isAssigned) assignedFleets.push(fleet.id)
                    })
                }
            })
            this.assignedOrganizations.splice(0, 0, ...assignedOrganizations)
            this.assignedFleets.splice(0, 0, ...assignedFleets)
        },
        async updateAssignedOrganizationsAndFleets (updatedFlatList) {
            if (!this.hasAllRoles(['UserUpdate'])) return
            this.isLoading = true

            const { organizationsToAssign, organizationsToUnassign, fleetsToAssign, fleetsToUnassign } = this.calculateDifferences(updatedFlatList)

            if (0 < organizationsToAssign.length) {
                const response = await userApi.assignUserToOrganizations(this.id, organizationsToAssign)
                if (!response.isSuccess) return
            }

            if (0 < organizationsToUnassign.length) {
                const response = await userApi.unassignUserFromOrganizations(this.id, organizationsToUnassign)
                if (!response.isSuccess) return
            }

            if (0 < fleetsToAssign.length) {
                const response = await userApi.assignUserToFleets(this.id, fleetsToAssign)
                if (!response.isSuccess) return
            }

            if (0 < fleetsToUnassign.length) {
                const response = await userApi.unassignUserFromFleets(this.id, fleetsToUnassign)
                if (!response.isSuccess) return
            }

            toast.success('New permissions assigned')
            this.isLoading = false
        },
        calculateDifferences (updatedFlatList) {
            const assignedOrganizations = []
            const assignedFleets = []
            updatedFlatList.forEach(org => {
                if (org.isAssigned) assignedOrganizations.push(org.id)
                org.fleets.forEach(fleet => {
                    if (fleet.isAssigned) assignedFleets.push(fleet.id)
                })
            })
            const dataForUpdate = {
                organizationsToUnassign: subtractSet(this.assignedOrganizations, assignedOrganizations),
                organizationsToAssign: subtractSet(assignedOrganizations, this.assignedOrganizations),
                fleetsToUnassign: subtractSet(this.assignedFleets, assignedFleets),
                fleetsToAssign: subtractSet(assignedFleets, this.assignedFleets)
            }
            return dataForUpdate
        },
        sortOrganizationsAndFleets (flatArray) {
            let idAsProperty = {}
            flatArray.sort((a, b) => ('' + a.name).localeCompare(b.name))
            for (const organization of flatArray) {
                organization.fleets.sort((a, b) => ('' + a.name).localeCompare(b.name))
                idAsProperty[organization.id] = organization
            }
            this.idsAsProperties = idAsProperty
        }
    }
}
</script>
